import { render, staticRenderFns } from "./fpgDf.vue?vue&type=template&id=456fcdb4&scoped=true"
import script from "./fpgDf.vue?vue&type=script&lang=js"
export * from "./fpgDf.vue?vue&type=script&lang=js"
import style0 from "./fpgDf.vue?vue&type=style&index=0&id=456fcdb4&prod&lang=scss"
import style1 from "./fpgDf.vue?vue&type=style&index=1&id=456fcdb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456fcdb4",
  null
  
)

export default component.exports